import { clearCompanyContentKeys } from "./companyContentKeys";
import { clearActiveCompanyKey } from "./encryptForCompany";

// Higiena materiału kluczowego przy wylogowaniu (docs/model-kluczy-firmowych.md, F8).
//
// PRZED tą zmianą `clearKeysCache` (utils/getKeys.ts) było wyeksportowane, ale nie miało
// ANI JEDNEGO wołającego: cache odszyfrowanego klucza master/intermediate przeżywał
// wylogowanie w pamięci procesu, mirror kluczy firmy (utils/companyContentKeys.ts) nie był
// czyszczony z tego miejsca, a `${userId}.keys`/`${userId}.recov` nigdy nie znikały z
// localStorage. Na wspólnym stanowisku (recepcja, komputer kancelaryjny) kolejny zalogowany
// użytkownik dostawał czystą sesję OIDC, ale STARY materiał kluczowy leżał dalej w tej samej
// przeglądarce.
//
// WOŁAĆ PRZED auth.signoutRedirect() (i przed każdym innym wyjściem z sesji — usunięcie
// konta, rezygnacja z odzyskiwania), z userId wziętym z auth.user, ZANIM wylogowanie go
// wyczyści. Nawigacja do IdP i tak resetuje pamięć procesu (pełne przeładowanie strony) —
// ale localStorage przeżywa nawigację, więc usunięcie tych wpisów jest właściwym powodem
// istnienia tej funkcji, a czyszczenie mirrorów w pamięci to tylko dodatkowa siatka
// bezpieczeństwa (np. gdy signoutRedirect nie zdąży przekierować od razu).
export const clearAllKeys = (userId?: string | null): void => {
  // (magistrat: utils/getKeys nie ma cache'u odszyfrowanych kluczy — nie ma czego czyścić)
  clearCompanyContentKeys();
  clearActiveCompanyKey();

  if (!userId) return;

  try {
    localStorage.removeItem(`${userId}.keys`);
    localStorage.removeItem(`${userId}.recov`);
    localStorage.removeItem(`${userId}.rk`);
  } catch {
    // localStorage niedostępny (tryb prywatny, zablokowany storage) — nie ma czego czyścić.
  }
};
